module.exports = __webpack_public_path__ + "media/cinfa.707fb60d.mp4";